export default {"src":"/_next/static/media/accommodation-icon.56fc0444.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};